export const ExpertsImageParams = {
    imgLS0:"Experts__PraveenRajaram.png",
    imgLS1:"Experts__SaraswathiSwaminathan.png",
    imgL0:"Experts__DhirenSinam.png",
    imgL1:"Experts__JagadeeshaHulikal.png",
    imgL2:"Experts__JaganathanThiyagarajan.png",
    imgL3:"Experts__RamapavaniPoruri.png",
    imgL4:"Experts__SateeshNalluri.png",
    imgL5:"Experts__ShyamBahadur.png",
    imgL6:"Experts__VaradharajanBalakrishnan.png",
    imgSME0:"Experts__AbdulSattarShaik.png",
    imgSME1:"Experts__AbhijeetKhurd.png",
    imgSME2:"Experts__AdinarayanaTalla.png",
    // imgSME3:"Experts__AishiPaul.png",
    imgSME3:"Experts__AiswaryaMurali.png",
    imgSME4:"Experts__AmitaMishra.png",
    imgSME5:"Experts__AnjayChakravarty.png",
    imgSME6:"Experts__ArnaKumari.png",
    imgSME7:"Experts__AthreshP.png",
    imgSME8:"Experts__AZHARUDDIN.png",
    imgSME9:"Experts__BasappaHallur.png",
    imgSME10:"Experts__ChaudhurySourya.png",
    imgSME11:"Experts__DevPawar.png",
    imgSME12:"Experts__DilipKumar.png",
    imgSME13:"Experts__Karthikeyan.png",
    imgSME14:"Experts__KudratAli.png",
    imgSME15:"Experts__KUMARSRINIVAS.png",
    imgSME16:"Experts__LavanyaVenkatesh.png",
    imgSME17:"Experts__LaxmiAhuja.png",
    imgSME18:"Experts__LokeshManjunath.png",
    imgSME19:"Experts__ManeruAshok.png",
    imgSME20:"Experts__Meenakshi.png",
    imgSME21:"Experts__PRAKASHARUMUGAM.png",
    imgSME22:"Experts__PremPratik.png",
    imgSME23:"Experts__PriitamTajne.png",
    imgSME24:"Experts__RamShekar.png",
    imgSME25:"Experts__RAVALAVENKAIAH.png",
    imgSME26:"Experts__SachinChandrashekar.png",
    imgSME27:"Experts__SATHYAMARIAPPAN.png",
    imgSME28:"Experts__SoumyadiptaDas.png",
    imgSME29:"Experts__SridharChalla.png",
    imgSME30:"Experts__SuryaPrakash.png",
    imgSME31:"Experts__SusmitaPanigrahi.png",
    imgSME32:"Experts__SwapnaliPatil.png",
    imgSME33:"Experts__VSAIPRAKASH.png",
    imgSME34:"Experts__Vikram.png",
    imgSME35:"Experts__Vinitha.png"
};
